import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import convertMillisecondsToDate from "../../services/dateconverter";
import formatStringWithSpaces from "../../services/stringconverter";
import EditIcon from "@mui/icons-material/Edit";
import truncateString from "../../services/truncatestring";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import getTimeDifference from "services/getTimeDefference";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";

export const Inspectioncolumns = [
  { name: "P.I.F.", align: "left" },
  { name: "Inspector", align: "left" },
  { name: "Date & Time", align: "center" },
  { name: "Inspection Type", align: "center" },
  { name: "Time on Site", align: "center" },
  { name: "Deficiency found", align: "center" },
  { name: "Status", align: "center" },
  { name: "Action", align: "center" },
];

function Rows(data, setDialogue) {

  return {
    linkPath: `/inspection-overview/${data._id}`,
    noLinkCells: ["Action"],
    "P.I.F.": (
      <Link to={`/inspection-overview/${data._id}`}>
        <SoftTypography
          variant="text"
          color="lightBlack"
          fontWeight="medium"
          textTransform="capitalize"
          fontSize="14px"
          sx={{
            display: "block",
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "180px",
          }}
        >
          {data?.is_deleted || data?.project_deleted
            ? `${data?.project_name}`
            : `${data?.project_name}-${data?.inspection_number}-${data?.inspection_discipline_start}`}{" "}
        </SoftTypography>
      </Link>
    ),
    Inspector: (
      <SoftTypography
        variant="text"
        color="lightBlack"
        fontWeight="medium"
        fontSize="16px"
        textTransform="capitalize"
        sx={{
          display: "block",
          whiteSpace: "normal",
          wordWrap: "break-word",
          maxWidth: "180px",
        }}
      >
        { data?.updated_inspector?._id? data?.updated_inspector?.full_name : data?.added_by?.full_name}
      </SoftTypography>
    ),

    "Inspection Type": (
      <SoftBox display="flex" flexDirection="column" alignItems="center">
        <SoftTypography
          variant="text"
          color="black"
          fontWeight="medium"
          fontSize="16px"
          textTransform="capitalize"
          sx={{ maxWidth: "120px" }}
        >
          {data?.discipline_data[0]?.inspectionType}
        </SoftTypography>
      </SoftBox>
    ),

    "Time on Site": (
      <SoftTypography
        variant="text"
        color="lightBlack"
        fontWeight="medium"
        fontSize="16px"
        textTransform="capitalize"
        display="inline-flex"
        alignItems="center"
        sx={{ maxWidth: "100px" }}
      >
        {getTimeDifference(data?.arrival_time, data?.time_left)}
      </SoftTypography>
    ),

    "Deficiency found": (
      <SoftBox display="flex" flexDirection="column" alignItems="center">
        <SoftTypography
          variant="text"
          color="lightBlack"
          fontWeight="medium"
          fontSize="16px"
          textTransform="uppercase"
          maxWidth="100px"
        >
          {formatStringWithSpaces(data?.deficiencies_found?.join(", "))}
        </SoftTypography>
      </SoftBox>
    ),

    "Date & Time": (
      <SoftBox display="flex" flexDirection="column" alignItems="center">
        <SoftTypography
          variant="text"
          color="lightBlack"
          fontWeight="regular"
          textTransform="none"
          fontSize="14px"
          maxWidth="100px"
          sx={{
            color: "#02255B",
          }}
        >
          {convertMillisecondsToDate(data?.createdTime)}
        </SoftTypography>
      </SoftBox>
    ),
    Status: (
      <SoftTypography
        variant="text"
        color="lightBlack"
        fontWeight="medium"
        textTransform="capitalize"
        padding="18px 0px !important"
        sx={{
          display: "block",
          whiteSpace: "normal",
          wordWrap: "break-word",
          maxWidth: "150px",
          lineHeight: "21px",
          color:
            data?.is_deleted || data?.project_deleted
              ? "error.main"
              : data?.status === "new_report"
              ? "#006903"
              : data?.status === "under_manager_review"
              ? "#BC6809"
              : data?.status === "under_editor_final_review"
              ? "#105DB5"
              : "lightBlack",
        }}
      >
        {data?.is_deleted || data?.project_deleted
          ? "Reports Deleted"
          : data?.status == "under_manager_review"
          ? "Under Review"
          : data?.status == "under_editor_final_review"
          ? "Final Review"
          : formatStringWithSpaces(data?.status)}
      </SoftTypography>
    ),
    Action: (
      <SoftBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={3}
        onClick={(e) => e.stopPropagation()}
      >
        {data?.is_deleted || data?.project_deleted ? (
          <SettingsBackupRestoreIcon
            sx={{
              cursor: "pointer",
              width: "24px",
              height: "24px",
              color: "info.main",
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setDialogue({
                type: "deleteInspection",
                isOpen: true,
                inspectionId: data._id,
                is_deleted: false,
                action: "restoreInspection",
              });
            }}
          />
        ) : (
          <DeleteIcon
            sx={{
              cursor: "pointer",
              width: "24px",
              height: "24px",
              color: "error.main",
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setDialogue({
                type: "deleteInspection",
                isOpen: true,
                inspectionId: data._id,
                is_deleted: true,
                action: "deleteInspection",
              });
            }}
          />
        )}

        {!data.is_deleted && (
          <Link to={`/update-inspection/${data?._id}`}>
            <EditIcon
              sx={{
                cursor: "pointer",
                width: "20px",
                height: "20px",
                color: "white.main",
                backgroundColor: "primary.main",
                padding: "2px",
                borderRadius: "50%",
                marginTop: "8px",
              }}
            />
          </Link>
        )}
      </SoftBox>
    ),
  };
}

export default Rows;
